import Typography from "@mui/material/Typography";

export function MultilineTypography({text, props, ...defaultProps}) {
	const lines = text.split(/[\n|\|]/)
	props ??= []
	return lines.map(
		(line, idx) =>
			<Typography {...{...defaultProps, ...props[idx]}}>
				{line}
			</Typography>
	)
}